export const showBootstrapModal = (modalId: string) => {
    window.setTimeout(() => {
        const modalElement = document.getElementById(modalId);
        if (modalElement) {
            (window as any).jQuery(modalElement).modal('show');
        }
    }, 100);
};
